import { AppProvider } from "./contexts";
import Routes from "./routes";

const App = () => {
  return (
    <AppProvider>
      <Routes />
    </AppProvider>
  );
};

export default App;
